
























import {Component, Emit, Model, Prop} from "vue-property-decorator";
import {PostOfficeStore} from "@/modules/postoffices/store";
import debounce from "lodash/debounce";
import PostOfficeLabel from "@/modules/postoffices/List/components/Label.vue";
import {PostOfficeParams} from "@/modules/postoffices/params";
import {CommonStatus} from "@/enums/status";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";

@Component({
    name: "PostOfficeSelector",
    components: {PostOfficeLabel}
})
export default class extends mixins(CommonMixin) {
    @Model("change")
    readonly postOfficeRowGuid!: string|string[];

    @Emit('change')
    handleChange(value: number) {
        return value;
    }

    @Prop({ default: "default", type: String })
    readonly mode!: string;

    @Prop({ default: false })
    readonly disabled!: boolean;

    @Prop({ default: "Chọn bưu cục", type: String })
    readonly placeholder!: string;
    
    @Prop({ default: false, type: Boolean })
    readonly hideCurrentPostOffice!: boolean;

    get ids(): string[] {
        return PostOfficeStore.ids;
    }

    isShowItem(id: string): boolean {
        return (!this.hideCurrentPostOffice || (this.hideCurrentPostOffice && id !== this.currentPostOffice?.rowGuid));
    }

    async created() {
        try {
            await PostOfficeStore.listPostOffice({ ...new PostOfficeParams(), status: CommonStatus.Active });
        } catch (e) {
            this.$notification.error({ message: "Thất bại", description: e?.response?.data?.message || "Đã có lỗi xảy ra" });
        }
    }

    private onSearch = debounce(function (value: string) {
        PostOfficeStore.listPostOffice({ ...PostOfficeStore.params, search: value, status: CommonStatus.Active });
    }, 500);
}
